import BaseCommand from "./baseCommand";

class ToggleComponentLockCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const { toggleComponentLockUnlock, payload } = this.componentData;
    toggleComponentLockUnlock(payload);
  }

  undo() {
    const { toggleComponentLockUnlock, payload } = this.componentData;
    if (payload) {
      this.scrollIntoView(payload.activeComponentID);
    }
    const newPayload = { ...payload };
    newPayload.lockStatus = !payload.lockStatus;
    toggleComponentLockUnlock(newPayload);
  }
}

export default ToggleComponentLockCommand;



// WEBPACK FOOTER //
// ./src/commands/toggleComponentLockCommand.js